// extracted by mini-css-extract-plugin
export default {"page_img":"errorpage_page_img__KBYA-","error_page":"errorpage_error_page__3iPax"};